export default __webpack_public_path__ + "static/media/Pulmini.285a33eb.jpg";